var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"modal",on:{"click":_vm.hide}},[_c('img',{attrs:{"src":_vm.images[0]},on:{"click":function($event){$event.stopPropagation();}}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }